import { Pipe, PipeTransform } from '@angular/core';
import { PaymentType } from "@afidium/ts-facade";
import { IMultiselectOptions } from "libraries/module/formbuilder/fields/multiselect/multiselect.model";
import { PAYMENT_OPTIONS } from "libraries/enums/payment-options";

@Pipe({
    name: 'extractFop'
})

export class ExtractFopPipe implements PipeTransform {
    public transform(payment: PaymentType): string {
        return payment ?
            Object.keys(payment.formOfPayment)
                .map((key: string): string=> {
                    const option: IMultiselectOptions = PAYMENT_OPTIONS
                        .find((optionItem: IMultiselectOptions): boolean => optionItem.value === key);
                    return option ? option.label : key;
                })
                .join(', '):
            null;
    }
}
